export const LANDING_CONTENT = {
  mysmartcv: {
    headline: 'landing.mysmartcv.title',
    subText: 'landing.mysmartcv.description',
    CTAButtonText: 'landing.mysmartcv.cta',
    steps: ['landing.mysmartcv.list_item_1', 'landing.mysmartcv.list_item_2', 'landing.mysmartcv.list_item_3'],
  },
};
